import Notifications from './notifications';

export default Notifications;